import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { LogoMark } from "@/components/Logo";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem("pwa-install-dismissed")) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) {
      const t = setTimeout(() => { setIosHint(true); setShow(true); }, 2500);
      return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", onPrompt); };
    }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("pwa-install-dismissed", "1");
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="pwa-install-banner"
      className="fixed bottom-4 inset-x-4 z-[60] sm:left-auto sm:right-4 sm:w-96 rounded-2xl bg-slate-900 text-white shadow-2xl border border-slate-700 p-4 flex items-start gap-3 animate-in slide-in-from-bottom-4">
      <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0 p-1"><LogoMark className="w-8 h-8" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">Install Arjun DSA App</div>
        {iosHint ? (
          <div className="text-xs text-slate-300 mt-1 flex items-center gap-1">
            Tap <Share size={13} className="inline text-emerald-400" /> then "Add to Home Screen"
          </div>
        ) : (
          <div className="text-xs text-slate-300 mt-1">Add to your home screen for quick, app-like access.</div>
        )}
        {!iosHint && (
          <button data-testid="pwa-install-button" onClick={install}
            className="mt-2 inline-flex items-center gap-1.5 bg-emerald-500 hover:bg-emerald-400 text-slate-900 text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors">
            <Download size={14} /> Install
          </button>
        )}
      </div>
      <button data-testid="pwa-install-dismiss" onClick={dismiss} className="text-slate-400 hover:text-white shrink-0"><X size={18} /></button>
    </div>
  );
}
